import React, { useId, useState } from 'react';
import { COPPER_GOLD_INTRO, REGIME_ROWS } from '../utils/copperGoldYieldSignal';

function CopperGoldYieldHelp() {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="copper-gold-help">
      <button
        type="button"
        className="copper-gold-help-trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        How to read this
      </button>
      {open && (
        <div id={panelId} className="copper-gold-help-panel" role="region" aria-label="Copper/gold vs 10Y guide">
          <p className="copper-gold-help-body">{COPPER_GOLD_INTRO}</p>
          <p className="copper-gold-help-body">
            Copper is &quot;Dr. Copper&quot; — industrial demand. Gold is the fear metal. Ratio up =
            optimism; down = caution. We correlate <strong>weekly</strong> log-changes in the ratio with
            weekly changes in the 10Y yield (percentage points), not raw levels.
          </p>
          <table className="copper-gold-regime-table">
            <thead>
              <tr>
                <th>26w corr</th>
                <th>Regime</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              {REGIME_ROWS.map((row) => (
                <tr key={row.id}>
                  <td>{row.range}</td>
                  <td>
                    {row.emoji} {row.label}
                  </td>
                  <td>{row.tooltip}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="copper-gold-help-note">
            When yields rise while the ratio falls, borrowing costs increase without a stronger growth
            signal — a tough mix for stocks and bonds (often alongside positive stock–bond correlation).
          </p>
        </div>
      )}
    </div>
  );
}

export default CopperGoldYieldHelp;
